import { ICityListRequestAbroad, IFirmListRequestAbroad } from './../types/FilterType'
import http from '../core/http-common'
import { ICityList, ICityListRequest, IFirmList, IFirmListRequest, IProperties } from '../types/FilterType'

class FilterService {
  getAuthCityList(request: ICityListRequest | ICityListRequestAbroad) {
    return http.post<ICityList[]>('/City/GetAuthCityList', request)
  }

  getFirmList(request: IFirmListRequest | IFirmListRequestAbroad) {
    return http.post<IFirmList[]>('/Firm/GetFirmList', request)
  }

  getAuthLocationProperties(isMyFirm: boolean) {
    return http.get<IProperties[]>('/Location/GetAuthLocationProperties?myFirm=' + isMyFirm)
  }

  getAuthBlockProperties(isMyFirm: boolean) {
    return http.get<IProperties[]>('/Block/GetAuthBlockProperties?myFirm=' + isMyFirm)
  }

  getAuthFloorProperties(isMyFirm: boolean) {
    return http.get<IProperties[]>('/Floor/GetAuthFloorProperties?myFirm=' + isMyFirm)
  }
}

export default new FilterService()
